import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import SocialMedia from "../common/SocialMedia";
import MenuModal from "../menu/MenuModal";

export default function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);

    // mobil menü açıkken sayfa scroll kilitle + ESC kapatma
    useEffect(() => {
        if (!mobileOpen) return;

        const onKey = (e) => {
            if (e.key === "Escape") setMobileOpen(false);
        };

        document.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";

        return () => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [mobileOpen]);

    return (
        <>
            <nav className="nav">
                <button
                    className="navLinkLike"
                    onClick={() => setMenuOpen(true)}
                    type="button"
                >
                    Menü
                </button>

                {/* Desktop linkler */}
                <div className="navLinksDesktop">
                    <NavLink to="/subeler">Şubeler</NavLink>
                    <NavLink to="/ekipman">Ekipman</NavLink>
                    <NavLink to="/cekirdekler">Çekirdekler</NavLink>
                    <a href="#contact">İletişim</a>
                    <SocialMedia variant="inline" />
                </div>

                {/* Mobile sağ ikonlar */}
                <div className="navRightMobile">
                    <SocialMedia variant="inline" />
                    <button
                        className="hamburger"
                        type="button"
                        aria-label="Menüyü aç"
                        aria-expanded={mobileOpen}
                        onClick={() => setMobileOpen(true)}
                    >
                        ☰
                    </button>
                </div>
            </nav>

            {/* ✅ MOBILE OVERLAY MENU (navbar yüksekliğini artırmaz) */}
            {mobileOpen && (
                <div className="mobileOverlay" onClick={() => setMobileOpen(false)}>
                    <div className="mobileSheet" onClick={(e) => e.stopPropagation()}>
                        <div className="mobileSheetHeader">
                            <div className="mobileSheetTitle">Menü</div>
                            <button
                                className="mobileClose"
                                type="button"
                                onClick={() => setMobileOpen(false)}
                                aria-label="Kapat"
                            >
                                ✕
                            </button>
                        </div>

                        <div className="mobileSheetLinks">
                            <NavLink to="/subeler" onClick={() => setMobileOpen(false)}>
                                Şubeler
                            </NavLink>
                            <NavLink to="/ekipman" onClick={() => setMobileOpen(false)}>
                                Ekipman
                            </NavLink>
                            <NavLink to="/cekirdekler" onClick={() => setMobileOpen(false)}>
                                Çekirdekler
                            </NavLink>
                            <a href="#contact">İletişim</a>
                        </div>

                        <div className="mobileSheetFooter">
                            <SocialMedia variant="inline" />
                        </div>
                    </div>
                </div>
            )}
            {menuOpen && (
                <MenuModal open={menuOpen} onClose={() => setMenuOpen(false)} />
            )

            }

        </>
    );
}